import clsx from 'clsx';
import { Icon } from '../Icon/Icon';
import { Text } from '../Text/Text';
import { stepperItem } from './base';

type StepperItemComponentProps = {
  step: number; // computed in Stepper
  text: string;
  ariaLabel: string;
  checked?: boolean;
  subdued?: boolean;
};
// omit computed step prop
export type StepperItemProps = Omit<StepperItemComponentProps, 'step'>;

export const StepperItem = ({
  step,
  text,
  ariaLabel,
  checked = false,
  subdued = false,
}: StepperItemComponentProps) => {
  const color = subdued ? 'contentSubdued' : 'contentDefault';

  const renderStepCompletedIcon = () => {
    return <Icon filled={checked} name="check_circle" color="text-primary" />;
  };

  const renderStepNumericIcon = () => {
    return (
      <div
        className={clsx(
          'flex flex-row space-x-s m-[2px] w-[20px] h-[20px] rounded-circle items-center justify-center',
          subdued ? 'bg-surface-disabled' : 'bg-primary',
        )}
      >
        <Text
          size="labelStrong"
          color={subdued ? 'contentSubdued' : 'contentInverse'}
        >
          {step}
        </Text>
      </div>
    );
  };

  return (
    <div className={stepperItem()} aria-label={ariaLabel}>
      {checked ? renderStepCompletedIcon() : renderStepNumericIcon()}
      <Text size="bodyL" color={color}>
        {text}
      </Text>
    </div>
  );
};
